import { Box } from '@mui/material'

declare type SectionHeaderProps = {
  title?: string
  subtitle?: string | JSX.Element
  containerStyles?: object
}

const SectionHeader = ({
  title,
  subtitle,
  containerStyles,
}: SectionHeaderProps) => {
  return (
    <Box
      component="div"
      sx={[
        {
          alignSelf: 'start',
          marginBottom: '20px',
        },
        containerStyles || {},
      ]}
    >
      {title && (
        <Box
          component="p"
          sx={{
            fontSize: '19px',
            fontWeight: 'bold',
            color: '#0a2435',
            textTransform: 'uppercase',
          }}
        >
          {title}
        </Box>
      )}
      {subtitle && (
        <Box
          component="p"
          sx={{ fontSize: '17px', fontWeight: 'light', color: '#414042' }}
        >
          {subtitle}
        </Box>
      )}
    </Box>
  )
}

export default SectionHeader
